import * as Yup from 'yup';
import validationMessages from 'common/lib/validationMessages';

Yup.setLocale(validationMessages);

export default Yup;
